<template>
  <div v-if="isAuthenticated">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="isBlocked" icon color="red" @click="unblock" v-bind="attrs" v-on="on" :loading="loading">
          <v-icon>mdi-bell-off</v-icon>
        </v-btn>
        <v-btn v-else icon color="grey" @click="block" v-bind="attrs" v-on="on" :loading="loading">
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </template>
      <span>{{ isBlocked ? 'Povoliť upozornenia' : 'Blokovať upozornenia' }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { APIService } from "@/http/APIService";
const apiService = new APIService();

export default {
  name: 'InlineNotificationControl',
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    pollId: {
      type: Number,
      default: null
    },
    moderatorId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('userNotifications', ['getPreferences']),
    isBlocked() {
      if (!this.getPreferences || !Array.isArray(this.getPreferences)) return false;

      if (this.categoryId) {
        return this.getPreferences.some(p => p.blocked_category === this.categoryId);
      }
      if (this.pollId) {
        return this.getPreferences.some(p => p.blocked_poll === this.pollId);
      }
      if (this.moderatorId) {
        return this.getPreferences.some(p => p.blocked_moderator === this.moderatorId);
      }
      return false;
    }
  },
  created() {
    // Ensure we have preferences loaded
    if (this.isAuthenticated && (!this.getPreferences || this.getPreferences.length === 0)) {
      this.fetchPreferences();
    }
  },
  methods: {
    ...mapActions('userNotifications', ['fetchPreferences']),

    async block() {
      if (!this.isAuthenticated) {
        return;
      }
      this.loading = true;
      try {
        if (this.categoryId) {
          await apiService.blockCategory(this.categoryId);
        } else if (this.pollId) {
          await apiService.blockPoll(this.pollId);
        } else if (this.moderatorId) {
          await apiService.blockModerator(this.moderatorId);
        }
        await this.fetchPreferences();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async unblock() {
      if (!this.isAuthenticated) {
        return;
      }
      this.loading = true;
      try {
        if (this.categoryId) {
          await apiService.unblockCategory(this.categoryId);
        } else if (this.pollId) {
          await apiService.unblockPoll(this.pollId);
        } else if (this.moderatorId) {
          // Unblocking a moderator is tricky because we need the preference ID to delete it via deletePreference generally
          // OR we use the unblockModerator endpoint if it exists and handles lookup.
          // unique unblock endpoints were added to API service: unblockCategory, unblockPoll...
          // Let's check APIService for unblockModerator
          await apiService.unblockModerator(this.moderatorId);
        }
        await this.fetchPreferences();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
